import { Component, Input } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { FileUploader } from 'ng2-file-upload';
import { FileUploadQueueService } from '../../../services/file-upload-queue.service';

/**
 * Dateien für die Wissensbasis auswählen.
 *
 * Der Dialog überträgt nichts selbst: „Hochladen" übergibt die Auswahl an
 * `FileUploadQueueService` und schließt sofort. Die Übertragung läuft dort
 * im Hintergrund weiter, den Stand zeigt `app-upload-tray` unten rechts —
 * der Nutzer muss kein Fenster offen halten.
 */
@Component({
  selector: 'app-file-upload-dialog',
  templateUrl: './file-upload-dialog.component.html',
  styleUrl: './file-upload-dialog.component.scss',
})
export class FileUploadDialogComponent {
  @Input() bucketId: string = '';

  // Nur Sammelbecken für Drop/Dateiauswahl (ng2FileDrop/ng2FileSelect) —
  // hochgeladen wird über den Queue-Dienst.
  public uploader: FileUploader = new FileUploader({ url: '' });

  hasBaseDropZoneOver = false;

  constructor(
    protected dialogRef: NbDialogRef<FileUploadDialogComponent>,
    protected uploadQueue: FileUploadQueueService,
    protected nbToastrService: NbToastrService,
  ) {
    this.uploader.onWhenAddingFileFailed = (item: any) => {
      this.nbToastrService.danger(
        `Datei "${item.name}" konnte nicht hinzugefügt werden`,
        'Datentyp nicht erlaubt.'
      );
    };
  }

  startUpload(): void {
    const files = this.uploader.queue
      .map((item) => item._file)
      .filter((file): file is File => !!file);
    if (!files.length || !this.bucketId) {
      return;
    }
    this.uploadQueue.enqueue(this.bucketId, files);
    this.dialogRef.close(true);
  }

  fileOverBase(e: any) {
    this.hasBaseDropZoneOver = true;
  }
}
